import { useEffect, useState } from "react";

export default function Menu() {
  const pdfUrl = `${process.env.PUBLIC_URL}/menu2.pdf`;

  // ✅ list your pages here
  const pages = [
    `${process.env.PUBLIC_URL}/menu-pages/menu2-1.png`,
    `${process.env.PUBLIC_URL}/menu-pages/menu2-2.png`,
    // add more if needed:
    // `${process.env.PUBLIC_URL}/menu-pages/menu-3.png`,
  ];

  const [isSmall, setIsSmall] = useState(window.innerWidth < 800);

  useEffect(() => {
    const onResize = () => setIsSmall(window.innerWidth < 800);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // 📱 Mobile: show images (perfect sizing + smooth scrolling)
  if (isSmall) {
    return (
      <div style={{ background: "#fff", padding: 0, margin: 0 }}>
        {pages.map((src, i) => (
          <img
            key={src}
            src={src}
            alt={`Menu page ${i + 1}`}
            style={{
              width: "100%",
              height: "auto",
              display: "block",
            }}
            loading="lazy"
          />
        ))}

        {/* optional: tiny link to PDF */}
        <div style={{ padding: 12, textAlign: "center" }}>
          <a href={pdfUrl} target="_blank" rel="noreferrer">
            View PDF
          </a>
        </div>
      </div>
    );
  }

  // 🖥 Desktop: show PDF full-screen (toolbar + zoom controls)
  return (
    <div style={{ position: "fixed", inset: 0, background: "#fff" }}>
      <iframe
        title="Menu PDF"
        src={pdfUrl}
        style={{ width: "100%", height: "100%", border: "none" }}
      />
    </div>
  );
}
